import { render, staticRenderFns } from "./dokumen_OPD.vue?vue&type=template&id=2a5da07f&"
import script from "./dokumen_OPD.vue?vue&type=script&lang=js&"
export * from "./dokumen_OPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports